// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import DateRange from 'common/domain/DateRange';

import DemographyGraph from './DemographyGraph';

import CombinedSummaryMetrics from './CombinedSummaryMetrics';
import Opportunity from '../../proposition/domain/opportunity';
import Proposition from '../../proposition/domain/proposition';
import OpportunityCard from './OpportunityCard';

const SalesContainer = styled.div`
  display: flex;
  width: 80%;
  flex:1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
`;

const Disclaimer = styled.div`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  align-self: center;
  margin-bottom: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const DemographyWrapper = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.metrics.margin}px;
`;

type Props = {
  proposition: Proposition,
  dateRange?: ?DateRange,
  t: any,
};

function PropositionDetail(props: Props) {
  const { t, proposition } = props;
  const { opportunities, genderDemography, ageGroup, metricsDateRange } = proposition.estimation;

  return (
    <SalesContainer>
      <Disclaimer>{t('propositionInformationMessage', {
        from: metricsDateRange.from,
        to: metricsDateRange.to,
      })}</Disclaimer>
      {
        opportunities.map((opportunity: Opportunity) => (
          <OpportunityCard opportunity={opportunity} index={opportunity.queryId} key={opportunity.queryId} />
        ))
      }
      <CombinedSummaryMetrics proposition={proposition} />
      <DemographyWrapper>
        <DemographyGraph genderDemography={genderDemography} ageGroup={ageGroup} />
      </DemographyWrapper>
    </SalesContainer>
  );
}

export default translate('commonSales')(PropositionDetail);



// WEBPACK FOOTER //
// ./src/common/modules/sales/components/PropositionDetail.js